import { render, staticRenderFns } from "./datedowns.vue?vue&type=template&id=f9edf62a&scoped=true"
import script from "./datedowns.vue?vue&type=script&lang=js"
export * from "./datedowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9edf62a",
  null
  
)

export default component.exports